<template>
    <button
        v-tippy="t('editorSetHorizontalRule')"
        :class="[
            buttonState(editor.can().setHorizontalRule(), editor.isActive('horizontal-rule')),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().setHorizontalRule()"
        @click="editor.chain().focus().setHorizontalRule().run()"
    >
        <MdiMinus class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiMinus from 'materialdesignicons-vue3/icons/MdiMinus.js';

    defineExpose({
        name: 'HorizontalRuleButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
